module.exports = __webpack_public_path__ + "static/logo-white-small-28ab4e65a4e8611ff222cf4453959cff.svg";